import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {AccountingService} from "./accounting.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {exposeComponentInDebugMode} from "../misc/expose-component-in-debug-mode.decorator";
import {AccountInfoModel} from "./accounting.gql-model";
import {toggleLoading} from "../misc/loading.decorator";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

export interface CARDAccountDialogModel {
  projectId: string;
}

@Component({
  templateUrl: "./import-card-accounts-dialog.template.pug",
  providers: [
    AccountingService,
  ],
})
@exposeComponentInDebugMode()
export class ImportCARDAccountsDialogComponent extends DialogComponent<CARDAccountDialogModel, boolean>
  implements CARDAccountDialogModel {
  error: Error;
  processing: boolean = false;
  orderName: string;
  projectId: string;
  listAccounts: AccountInfoModel[] = [];
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";

  static show(dialogService: DialogService, projectId: string): Promise<boolean> {
    return dialogService.showDialog(ImportCARDAccountsDialogComponent, {projectId});
  }

  constructor(
    public dialogService: DialogService,
    private accountingService: AccountingService,
  ) {
    super(dialogService);

    this.result = false;
  }

  cancel(): void {
    this.close();
    this.result = false;
  }

  @toggleLoading("processing")
  @handleErrors()
  async loadData() {
    const accounts = await this.accountingService.getAccountList(
      this.projectId,
      this.searchText,
      +this.currentPage - 1,
      +this.pageSize,
    );

    this.listAccounts = accounts.rows;
    this.totalCount = accounts.count;
    this.recalculateMaxPages();
  }

  ready() {
    this.loadData();
  }

  async selectAccount(id) {
    const result = this.listAccounts.find(account => account.id === id);
    await this.accountingService.setAccountToProject(this.projectId, result.id);
    this.close();
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }

    this.loadData();
    this.totalCount = this.listAccounts.length;
    this.recalculateMaxPages();
  }

  private recalculateMaxPages() {
    this.maxPages = Math.ceil(this.totalCount / (+this.pageSize));
  }
}
